import styled from 'styled-components';
import { doodles } from '../../../styles/decor';

export const HeaderArea = styled.header`
    position:sticky;
    top:0;
    z-index:50;
    background-color:var(--salato-header-red);
    background-image:${doodles('#ffffff', .09)};
    background-size:200px;
    padding-top:var(--safe-area-top);
    box-shadow:inset 0 -4px 0 var(--salato-yellow);
    transition:box-shadow .3s ease;

    &.is-scrolled{
        box-shadow:inset 0 -4px 0 var(--salato-yellow), 0 10px 30px rgba(120, 10, 10, .22);
    }

    .container{
        max-width:1240px;
        margin:0 auto;
        height:var(--header-h);
        padding:0 24px 4px;
        display:flex;
        align-items:center;
        gap:32px;
        transition:height .3s var(--ease-out);
    }

    &.is-scrolled .container{
        height:64px;
    }

    .logo{
        display:flex;
        align-items:center;
        flex-shrink:0;

        img{
            width:118px;
            height:auto;
            display:block;
            filter:drop-shadow(0 2px 4px rgba(120, 10, 10, .25));
            transition:width .3s var(--ease-out), transform .3s var(--ease-out);
        }

        &:hover img{
            transform:rotate(-2deg) scale(1.03);
        }
    }

    &.is-scrolled .logo img{
        width:98px;
    }

    .navMain{
        flex:1;
        display:flex;
        justify-content:center;

        ul{
            display:flex;
            gap:4px;
            margin:0;
            padding:0;
            list-style:none;
        }

        a{
            position:relative;
            display:inline-flex;
            align-items:center;
            height:40px;
            padding:0 16px;
            border-radius:999px;
            color:#fff;
            font-size:16px;
            font-weight:600;
            text-decoration:none;
            transition:background-color .2s ease, color .2s ease;

            &::after{
                content:'';
                position:absolute;
                left:50%;
                bottom:4px;
                width:18px;
                height:3px;
                border-radius:999px;
                background:var(--salato-yellow);
                transform:translateX(-50%) scaleX(0);
                transition:transform .25s var(--ease-out);
            }

            &:hover{
                background:rgba(255,255,255,.12);
            }

            &.active{
                color:var(--salato-yellow);

                &::after{
                    transform:translateX(-50%) scaleX(1);
                }
            }
        }
    }

    .navRight{
        display:flex;
        align-items:center;
        gap:18px;
    }

    .socialArea{
        display:flex;
        align-items:center;
        gap:4px;

        a{
            width:38px;
            height:38px;
            display:inline-flex;
            align-items:center;
            justify-content:center;
            border-radius:12px;
            transition:background-color .2s ease, transform .2s ease;

            &:hover{
                background:rgba(255,255,255,.14);
                transform:translateY(-1px);
            }
        }

        img{
            width:22px;
            height:22px;
            display:block;
        }
    }

    .ctaButton{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        height:42px;
        padding:0 18px;
        border-radius:999px;
        background:var(--salato-yellow);
        color:var(--salato-red-strong);
        font-weight:700;
        font-size:14px;
        text-decoration:none;
        white-space:nowrap;
        box-shadow:0 6px 16px rgba(0,0,0,.14);
        transition:transform .2s var(--ease-out), box-shadow .2s ease;

        &:hover{
            transform:translateY(-1px);
            box-shadow:0 10px 22px rgba(0,0,0,.18);
        }
    }

    .menuButton{
        display:none;
        width:44px;
        height:44px;
        border:0;
        border-radius:12px;
        background:rgba(255,255,255,.14);
        cursor:pointer;
        position:relative;
        z-index:62;
        padding:0;

        span{
            position:absolute;
            left:12px;
            width:20px;
            height:2px;
            border-radius:2px;
            background:#fff;
            transition:transform .3s var(--ease-out), opacity .2s ease, top .3s var(--ease-out);
        }

        span:nth-child(1){ top:15px; }
        span:nth-child(2){ top:21px; }
        span:nth-child(3){ top:27px; }

        &.is-open{
            span:nth-child(1){ top:21px; transform:rotate(45deg); }
            span:nth-child(2){ opacity:0; }
            span:nth-child(3){ top:21px; transform:rotate(-45deg); }
        }
    }

    .mobileBackdrop,
    .mobileDrawer{
        display:none;
    }

    @media (max-width:980px){
        --header-h:64px;

        .container{
            padding:0 16px 4px;
            justify-content:space-between;
            gap:12px;
        }

        &.is-scrolled .container{
            height:58px;
        }

        .navMain,
        .navRight{
            display:none;
        }

        .menuButton{
            display:block;
        }

        .logo{
            position:absolute;
            left:50%;
            transform:translateX(-50%);

            img{ width:96px; }
        }

        &.is-scrolled .logo img{
            width:86px;
        }

        .mobileBackdrop{
            display:block;
            position:fixed;
            inset:0;
            background:rgba(20,8,6,.45);
            backdrop-filter:blur(3px);
            opacity:0;
            pointer-events:none;
            transition:opacity .3s ease;
            z-index:60;

            &.is-open{
                opacity:1;
                pointer-events:auto;
            }
        }

        .mobileDrawer{
            display:flex;
            flex-direction:column;
            gap:20px;
            position:fixed;
            top:0;
            left:0;
            bottom:0;
            width:min(84vw, 320px);
            padding:calc(20px + var(--safe-area-top)) 18px calc(24px + var(--safe-area-bottom));
            background-color:var(--salato-header-red);
            background-image:${doodles('#ffffff', .08)};
            background-size:200px;
            box-shadow:24px 0 48px rgba(0,0,0,.22);
            transform:translateX(-102%);
            transition:transform .35s var(--ease-out);
            z-index:61;
            overflow-y:auto;

            &.is-open{
                transform:none;
            }
        }

        .drawerHeader{
            padding:4px 4px 12px 56px;
            border-bottom:1px solid rgba(255,255,255,.18);

            img{
                width:96px;
                display:block;
            }
        }

        .mobileDrawer nav ul{
            display:flex;
            flex-direction:column;
            gap:6px;
            margin:0;
            padding:0;
            list-style:none;
        }

        .mobileDrawer nav a{
            display:flex;
            align-items:center;
            height:50px;
            padding:0 16px;
            border-radius:14px;
            color:#fff;
            font-size:17px;
            font-weight:600;
            text-decoration:none;
            transition:background-color .2s ease;

            &:hover{ background:rgba(255,255,255,.12); }

            &.active{
                background:#fff;
                color:var(--salato-red);
            }
        }

        .drawerCta{
            height:50px;
            font-size:15px;
        }

        .drawerSocial{
            margin-top:auto;
            display:flex;
            flex-direction:column;
            gap:4px;
            padding-top:16px;
            border-top:1px solid rgba(255,255,255,.18);

            a{
                display:flex;
                align-items:center;
                gap:12px;
                height:44px;
                padding:0 12px;
                border-radius:12px;
                color:#fff;
                text-decoration:none;
                font-weight:500;

                &:hover{ background:rgba(255,255,255,.12); }
            }

            img{
                width:22px;
                height:22px;
            }
        }
    }
`;
